import i18next from 'i18next';
import languageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import {
  AvailableLanguages,
  fallbackLanguage,
  isSupportedLanguage,
  languageDetectionOptions,
  supportedLanguages,
} from './i18nConfig';
import translationsEn from 'translations/en.json';
import translationsNb from 'translations/nb.json';
import translationsFi from 'translations/fi.json';

export const translationResources = {
  [AvailableLanguages.en]: { translation: translationsEn },
  [AvailableLanguages.nb]: { translation: translationsNb },
  [AvailableLanguages.fi]: { translation: translationsFi },
} as const;

const getPathParts = (): string[] =>
  globalThis.location.pathname.split('/').filter(Boolean);

const ensurePathLanguage = (language?: string): void => {
  if (!isSupportedLanguage(language)) {
    return;
  }

  const pathParts = getPathParts();
  const hasLanguageInPath = isSupportedLanguage(pathParts[0]);
  const remainingParts = hasLanguageInPath ? pathParts.slice(1) : pathParts;
  const newPath = `/${[language, ...remainingParts].join('/')}`;

  if (globalThis.location.pathname !== newPath) {
    globalThis.history.replaceState(
      globalThis.history.state,
      '',
      `${newPath}${globalThis.location.search}${globalThis.location.hash}`,
    );
  }
};

// eslint-disable-next-line import-x/no-named-as-default-member
void i18next
  .use(initReactI18next)
  .use(languageDetector)
  .init({
    resources: translationResources,
    detection: languageDetectionOptions,
    fallbackLng: fallbackLanguage,
    supportedLngs: supportedLanguages,
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
  });

ensurePathLanguage(i18next.language);

i18next.on('languageChanged', (language) => {
  ensurePathLanguage(language);
});

export default i18next;
